var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-7"},[_c('v-select',{attrs:{"options":_vm.meses,"placeholder":"Mês","filterable":true},model:{value:(_vm.mes),callback:function ($$v) {_vm.mes=$$v},expression:"mes"}})],1),_vm._v(" "),_c('div',{staticClass:"col-lg-5"},[_c('v-select',{attrs:{"options":_vm.anos,"placeholder":"Ano","filterable":true},model:{value:(_vm.ano),callback:function ($$v) {_vm.ano=$$v},expression:"ano"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c56ffce","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/select-dib.vue
// module id = 805
// module chunks = 245